import Axios from "axios";

export const GetRegFrsCod = (a, b, c, d, e) => {
  return (dispatch) => {
    Axios.get(
      `https://www.24-crm.tn/webservice/api/BCDVCLIs?REG=REGF&coddos=${a}&serveur=${b}&user=${c}&pwd=${d}&database=${e}`
    ).then((response) => {
      return dispatch({ type: "REGFRSCOD", payload: response.data });
    });
  };
};

